<template>
    <section class="fake-blocks-container">
        <div class="fake-block">
            <div class="fake-line"/>
            <div class="fake-line"/>
            <i class="fake-icon"/>
        </div>
        <div class="fake-block">
            <div class="fake-line"/>
            <div class="fake-line"/>
            <div class="fake-line thin w-75"/>
            <div class="fake-line bottom w-50 thin"/>
            <i class="fake-icon"/>
        </div>
        <div class="fake-block horizontal">
            <div class="fake-line"/>
            <i class="fake-icon"/>
        </div>
        <div class="fake-block fake-cpg fade horizontal">
            <div class="fake-line first"/>
            <div class="fake-line thick second"/>
            <div class="fake-line thin third"/>
            <div class="fake-line bottom right thick"/>
        </div>
        <div class="fake-block fake-bundle fade horizontal">
            <div class="fake-layer"> <i class="fake-icon free"/> </div>
            <div class="fake-line fake-label"/>
            <div class="fake-line fake-name"/>
            <div class="fake-line fake-name"/>
            <div class="fake-line fake-label bottom"/>
        </div>
    </section>
</template>

<script>

export default {
    name: 'FakeBlocks',
    components: {
    },
    props: {
    },
    created() {
    },
    data() {
        return {}
    },
    watch: {},
    methods: {},
    computed: {

    },
}
</script>

<style lang="scss">
    //@import "../styles/pdpGrid";
    @import '../../../../scss/CalcSize.scss';
    .fake-blocks-container {
        position: relative;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(4, auto);
        grid-auto-flow: dense;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: responsive(20px);
        height: auto;
        margin: 0;
        box-sizing: border-box;
        padding: 0;

        .fake-block {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            transition: all 150ms linear;
            height: fit-content;
            border-radius: 20px;
            overflow: hidden;
            flex-grow: 1;
            aspect-ratio: 1;
            background: #DDD;
            padding: responsive(20px);
            gap: responsive(10px);

            &.fade {
                opacity: 0.65;
            }

            &.horizontal {
                aspect-ratio: 516 / 250; // + compensate gap
                grid-column-end: span 2;
            }

            .fake-line {
                width: 60%;
                min-width: responsive(72px);
                height: responsive(36px);
                background: #fff;
                border-radius: 20px;

                &.thin {
                    height: responsive(20px);
                }
                &.thick {
                    height: responsive(46px);
                }

                &.bottom {
                    margin: auto 0 responsive(10px) 0;
                }

                &.right {
                    margin: auto 0 responsive(10px) auto;
                }
            }

            .fake-layer {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                z-index: 1;
            }

            i.fake-icon {
                position: absolute;
                right: responsive(20px);
                bottom: responsive(20px);
                width: responsive(40px);
                height: responsive(40px);
                border-radius: 50%;
                background: #fff;

                &.free {
                    position: relative;
                    right: auto;
                    bottom: auto;
                    width: responsive(48px);
                    height: responsive(48px);
                }
            }

            &.fake-cpg {
                .first {
                    max-width: responsive(52px);
                }

                .second {
                    max-width: responsive(156px);
                }

                .third {
                    max-width: responsive(188px);
                }

                .bottom {
                    max-width: responsive(108px);
                }
            }

            &.fake-bundle {
                justify-content: flex-end;
                .fake-label {
                    position: absolute;
                    top: responsive(20px);
                    right: responsive(20px);
                    width: responsive(66px);
                    height: responsive(22px);

                    &.bottom {
                        top: auto;
                        bottom: responsive(20px);
                        width: responsive(46px);
                        margin: 0;
                    }
                }

                .fake-name {
                    max-width: responsive(212px);
                    height: responsive(20px);
                }

            }
        }

    }
</style>
